var DialogCreateMaintenanceModule = /** @class */ (function () {
    function DialogCreateMaintenanceModule() {
    }
    return DialogCreateMaintenanceModule;
}());
export { DialogCreateMaintenanceModule };
